import {Kpi} from '@hconnect/common/types'
import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '@settings/api/mutations'
import {invalidateSettingsQuery} from '@settings/modules/common/providers'
import {ErrorResponse} from '@settings/modules/common/types'
import {notifyIfErrorMessage} from '@settings/modules/common/utils'

export const useEditKpiUnit = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<Kpi, AxiosError<ErrorResponse>, Parameters<typeof mutations.editKpiUnit>[0]>({
    mutationFn: mutations.editKpiUnit,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.message, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.editKpiUnit'))
    },
    onSettled: () => {
      invalidateSettingsQuery('kpis')
    }
  })
}
